import { APP_THEME_PATH_PREFIXES } from "@/lib/theme/app-theme";

export const ASK_PANEL_HIDDEN_KEY = "ask-repackify-panel-hidden";
export const ASK_PANEL_OPEN_QUERY = "(min-width: 1280px)";

export const ASK_PANEL_SCRIPT = `(function(){var a=${JSON.stringify(APP_THEME_PATH_PREFIXES)},l=location.pathname;if(a.some(function(x){return l===x||l.indexOf(x+"/")===0}))return;var h;try{h=localStorage.getItem("${ASK_PANEL_HIDDEN_KEY}")==="1"}catch(e){}if(!h&&window.matchMedia("${ASK_PANEL_OPEN_QUERY}").matches)document.documentElement.setAttribute("data-ask-panel","open")})()`;
